import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { ListarMinutaGrilla } from './components/ListarMinutaGrilla';

export default function ListarMinuta() {
  return (
    <>
      <MainContent
        titulo='Listar Minuta'
        component={<ListarMinutaGrilla />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}